// extracted by mini-css-extract-plugin
module.exports = {"workExperiences":"workExperiences_workExperiences__3UV-u","heading":"workExperiences_heading__sEtGy","wrapper":"workExperiences_wrapper__1F4rT"};